gsap.registerPlugin(DrawSVGPlugin, Draggable, ScrollTrigger, InertiaPlugin, CustomEase);
gsap.defaults({ lazy: false });

const isIpadIos = () => (
  !!navigator.maxTouchPoints &&
  navigator.maxTouchPoints > 2 &&
  /MacIntel/.test(navigator.platform)
);

const isTouchDevice = bowser.mobile || bowser.tablet || isIpadIos();
const isDesktopDevice = !isTouchDevice;

if(isTouchDevice) document.documentElement.classList.add('is-touch');
if(isDesktopDevice) document.documentElement.classList.add('is-desktop');

const getRandomNumber = (min, max) => {
  return Math.random() * (max - min) + min;
};
let previousWindowWidth = 0;
let fullViewportHeight = 0;
let initialViewportHeight = 0;
let siteHeaderHeight = 0;
const isAdminMode = document.body.classList.contains('admin-bar');

const updateInitialViewportHeight = (isInitial) => {
  if (previousWindowWidth === window.innerWidth && bowser.ios) return;
  previousWindowWidth = window.innerWidth;
  const fullHeightElement = document.createElement('div');
  fullHeightElement.style.height = '100vh';
  document.body.appendChild(fullHeightElement);
  const fullHeightElementHeight = fullHeightElement.offsetHeight;
  fullViewportHeight = fullHeightElementHeight;
  fullHeightElement.remove();
  if (bowser.ios && fullHeightElementHeight === window.innerHeight && !isInitial) return;
  initialViewportHeight = window.innerHeight;
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
  document.documentElement.style.setProperty('--full-vh', `${fullViewportHeight}px`);
};

const handleWindowResize = (isInitial = false) => {
  updateInitialViewportHeight(isInitial);
  siteHeaderHeight = document.querySelector('[data-component-site-header] .navigation').offsetHeight;
  document.documentElement.style.setProperty('--site-header-height', `${siteHeaderHeight}px`);
  if (isAdminMode) {
    setTimeout(() => {
      const adminBar = document.getElementById('wpadminbar');
      if (adminBar) {
        document.documentElement.style.setProperty('--admin-bar-height', `${adminBar.offsetHeight}px`);
      }
    }, 100);
  }
};

handleWindowResize(true);
window.addEventListener('resize', () => handleWindowResize());

function lerp(v0, v1, t) {
  return v0*(1-t)+v1*t;
}


if(document.querySelector('.replytext')) {
  // add timeout of 2 seconds to scroll to the replytext
  setTimeout(() => {
    const replytext = document.querySelector('.replytext');
    replytext.scrollIntoView({ 
      behavior: 'smooth' 
    });
  }, 500);

}

// this function is a workaround for the WP Usermanager form not working with the novalidate attribute
if(document.getElementById('wpum-submit-registration-form') && !document.body.classList.contains('page-id-25885')) {
  document.getElementById('wpum-submit-registration-form').setAttribute('novalidate', 'novalidate');
}